import React, { useState } from 'react';

// @material-ui/core
import Box from '@material-ui/core/Box';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const MYLOFT_BASE_URL = 'https://app.myloft.xyz/institute/cmoqugdzu3wbevj01umwuntiq?url=/browse/search/local';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        borderBottomWidth: '1px',
        borderBottomColor: theme.palette.colors.fillStroke[200],
        borderBottomStyle: 'solid',
        width: '100%',
        padding: '0 16px',
    },
    input: {
        flex: 1,
    },
    closeIconButton: {
        color: theme.palette.colors.white,
        padding: 4,
    },
    powered: {
        fontSize: 11,
        color: theme.palette.colors.fillStroke[200],
        whiteSpace: 'nowrap',
        marginLeft: 12,
    },
    poweredLink: {
        color: theme.palette.colors.fillStroke[200],
        textDecoration: 'underline',
        fontWeight: 600,
    },
}));

const SearchLibrary = () => {
    const classes = useStyles();
    const [query, setQuery] = useState('');

    const handleSearch = (event) => {
        if (event.key === 'Enter') {
            const term = query.trim();
            if (!term) return;

            const myloftUrl = `${MYLOFT_BASE_URL}?search=${encodeURIComponent(term)}&tab=0`;
            window.open(myloftUrl, '_blank', 'noopener');
        }
    };

    const handleClear = () => {
        setQuery('');
    };

    return (
        <Box display="flex" alignItems="center" className={classes.root}>
            <InputBase
                className={classes.input}
                placeholder="Buscar libros"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyPress={handleSearch}
                startAdornment={<i className="ri-search-line font-size-24" />}
                endAdornment={
                    <Box visibility={query.trim().length ? 'visible' : 'hidden'}>
                        <IconButton
                            aria-label="clear"
                            className={classes.closeIconButton}
                            onClick={handleClear}
                        >
                            <i className="ri-close-line font-size-24" />
                        </IconButton>
                    </Box>
                }
                fullWidth
                inputProps={{ 'aria-label': 'Search library' }}
            />
            <Typography className={classes.powered} component="span">
                Powered by{' '}
                <Link
                    className={classes.poweredLink}
                    href="https://app.myloft.xyz"
                    target="_blank"
                    rel="noopener"
                >
                    MyLOFT
                </Link>
            </Typography>
        </Box>
    );
};

export default SearchLibrary;
